export default __webpack_public_path__ + "static/5step-aab056554b3b270247bb71c8f240fcd7.png";